<template>
  <!-- <div class="copyright">@2022 Therma-Stor LLC. All Rights Reserved. App Version: {{version}}</div> -->
  <div id="copy" class="copyright">
    © 2022–<span id="year">{{ year }} </span>&nbsp;Therma-Stor LLC. All Rights Reserved. App Version: {{ version }}
  </div>
</template>
<style lang="scss" scoped>
.copyright {
  color: var(--placeholder);
}
</style>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';

export default defineComponent({
  name: 'TheFooter',
  setup() {
    const version = ref<string>();
    const year = ref<number>();
    onMounted(() => {
      version.value = process.env.VUE_APP_VERSION;
      year.value = new Date().getFullYear();
    });

    return { version, year };
  },
});
</script>
